import React from 'react';
import { APP_STORE_LINKS } from '../constants/appLinks';

const PERKS = ['AI community chat', 'Push notifications', 'Event reminders', 'Offline access', 'Private messaging'];

export const AppDownloadStrip: React.FC = () => {
  return (
    <section className="px-6 py-16 text-center" style={{ background: '#1a1f36' }}>
      <div className="max-w-2xl mx-auto">
        <div className="mb-4" style={{ display: 'flex', justifyContent: 'center' }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">Do much more with the Sahayy app</h2>
        <p className="text-gray-400 text-base mb-6 leading-relaxed">
          Chat with Commy — your AI community assistant, get notified instantly, set reminders and connect deeper with your community.
        </p>

        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {PERKS.map(p => (
            <span key={p} className="text-xs font-medium px-3 py-1.5 rounded-full" style={{ background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.7)', border: '1px solid rgba(255,255,255,0.1)' }}>
              {p}
            </span>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
          <a
            href={APP_STORE_LINKS.APPLE_APP_STORE}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-between rounded-2xl px-6 py-4 hover:border-indigo-400 hover:shadow-sm transition-all"
            style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)' }}
          >
            <div className="flex items-center gap-4">
              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 384 512" height="1.6em" width="1.6em" style={{ color: 'rgba(255,255,255,0.85)' }} xmlns="http://www.w3.org/2000/svg">
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
              </svg>
              <div className="text-left">
                <div className="font-bold" style={{ color: 'white' }}>App Store</div>
                <div className="text-xs" style={{ color: 'rgba(255,255,255,0.45)' }}>iPhone & iPad</div>
              </div>
            </div>
            <span className="font-bold text-sm" style={{ color: '#818cf8' }}>Download →</span>
          </a>

          <a
            href={APP_STORE_LINKS.GOOGLE_PLAY}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-between rounded-2xl px-6 py-4 hover:border-indigo-400 hover:shadow-sm transition-all"
            style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)' }}
          >
            <div className="flex items-center gap-4">
              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.6em" width="1.6em" style={{ color: 'rgba(255,255,255,0.85)' }} xmlns="http://www.w3.org/2000/svg">
                <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z" />
              </svg>
              <div className="text-left">
                <div className="font-bold" style={{ color: 'white' }}>Google Play</div>
                <div className="text-xs" style={{ color: 'rgba(255,255,255,0.45)' }}>Android devices</div>
              </div>
            </div>
            <span className="font-bold text-sm" style={{ color: '#818cf8' }}>Download →</span>
          </a>
        </div>
      </div>
    </section>
  );
};
